import { z } from 'zod'
import { DEFAULT_TEXT_SIZE } from '../constants/text-style.js'
import { optionalHexColorSchema } from '../validators/hex-color.validator.js'

/**
 * What text on a floor plan is, wherever it appears.
 *
 * Two things carry words on a plan: a **static label**, painted into a venue
 * space's background, and a **text annotation**, a movable object on an event
 * plan. They are different objects — one belongs to the space, the other to the
 * plan — but "text with a size and a color" is one idea, and it was drifting:
 * `fontSize` was required on one and optional on the other, and `color` existed
 * on one until it was copied onto the other by hand. Spread this into both so
 * the next field cannot land on only one of them.
 *
 * `fontSize` **defaults rather than being optional**. As an optional field its
 * default was re-invented by every consumer — 14 on the canvas, 16 in the SVG
 * export, 16 again in the panel — so the same label drew at one size and printed
 * at another. Defaulting it here means the value is settled by the time anything
 * reads it.
 */
export const textAnnotationFields = {
  text: z.string(),
  fontSize: z.number().positive().default(DEFAULT_TEXT_SIZE),
  color: optionalHexColorSchema,
}
